import React from 'react';
import styled from '../../styled';
import dayjs from './day';
const Label = styled.span `
  background-color: ${({ theme, backgroundColor }) => theme.colors[backgroundColor]};
  color: ${({ theme, textColor }) => theme.colors[textColor]};
  font-size: 0.625rem;
  line-height: 1.6;
  white-space: nowrap;
`;
const dateTimeLocaleFormatMap = {
    today: {
        date: {
            'zh-hant': 'LTS',
            'zh-cn': 'LTS',
            en: 'LTS',
            vi: 'LTS',
            th: 'LTS',
        },
        time: {
            'zh-hant': 'ah:mm',
            'zh-cn': 'ah:mm',
            en: 'h:mm a',
            vi: 'h:mm a',
            th: 'h:mm a',
        },
        dateTime: {
            'zh-hant': 'LT',
            'zh-cn': 'LT',
            en: 'LT',
            vi: 'LT',
            th: 'LT',
        },
    },
    currentYear: {
        date: {
            'zh-hant': 'MMMDo',
            'zh-cn': 'MMMDo',
            en: 'MMM D',
            vi: 'MMM D',
            th: 'MMM D',
        },
        time: {
            'zh-hant': 'MMMDo',
            'zh-cn': 'MMMDo',
            en: 'MMM D',
            vi: 'MMM D',
            th: 'MMM D',
        },
        dateTime: {
            'zh-hant': 'MMMDo ah:mm',
            'zh-cn': 'MMMDo ah:mm',
            en: 'MMM D [at] h:mm a',
            vi: 'MMM D [at] h:mm a',
            th: 'MMM D [เวลา] h:mm a',
        },
    },
    previousYear: {
        date: {
            'zh-hant': 'LL',
            'zh-cn': 'LL',
            en: 'MMM D, YYYY',
            vi: 'MMM D, YYYY',
            th: 'MMM D, YYYY',
        },
        time: {
            'zh-hant': 'LL',
            'zh-cn': 'LL',
            en: 'MMM D, YYYY',
            vi: 'MMM D, YYYY',
            th: 'MMM D, YYYY',
        },
        dateTime: {
            'zh-hant': 'LL ah:mm',
            'zh-cn': 'LL ah:mm',
            en: 'MMM D, YYYY [at] h:mm a',
            vi: 'MMM D, YYYY [at] h:mm a',
            th: 'MMM D, YYYY [เวลา] h:mm a',
        },
    },
};
const DateLabel = ({ date, locale = 'en', format = 'date', textColor = 'INK_600', backgroundColor = 'SNOW_100', }) => {
    const dayJSInstance = dayjs(locale, date);
    const dateNow = dayjs(locale);
    if (dayJSInstance.isSame(dateNow, 'day')) {
        return (React.createElement(Label, { textColor: textColor, backgroundColor: backgroundColor }, dayJSInstance.format(dateTimeLocaleFormatMap.today[format][locale])));
    }
    if (dayJSInstance.isSame(dateNow, 'year')) {
        return (React.createElement(Label, { textColor: textColor, backgroundColor: backgroundColor }, dayJSInstance.format(dateTimeLocaleFormatMap.currentYear[format][locale])));
    }
    return (React.createElement(Label, { textColor: textColor, backgroundColor: backgroundColor }, dayJSInstance.format(dateTimeLocaleFormatMap.previousYear[format][locale])));
};
export default DateLabel;
//# sourceMappingURL=DateLabel.js.map